export default {
  Login: {
    user: 'user',
    password: 'password',
    required: 'required.',
    loginFail: 'Incorrect user id or password',
    submit: 'submit'
  },
  Dashboard: {
    dashboard: 'Dashboard',
    os: 'OS',
    architecture: 'ARCHITECTURE',
    processor: 'PROCESSOR',
    address: 'ADDRESS',
    memory: 'Memory',
    storage: 'Storage'
  },
  channel: {
    configuration: 'Configuration',
    configurator: 'Configurator',

    driver: 'Driver',
    driverid: 'Driver Name',
    driverid_tip: 'Driver name should be unique',

    general_settings: 'General Settings',
    driver_specific: 'Driver Specific Settings',

    device: 'Device',
    deviceid: 'Device Name',
    deviceid_tip: 'Device name should be unique',

    address: 'Address',
    address_tip: 'Device address vary on driver',
    description: 'Description',
    description_tip: 'Describe what it is',
    settings: 'Settings',
    settings_tip: 'Device specific settings ',

    channel: 'Channel',
    channelid: 'Channel Name',
    channelid_tip: 'Channel name should be unique',

    samplingtimeout: 'Sampling Timeout',
    retryInterval: 'Connection Retry Interval',
    disabled: 'Disabled',

    samplingtimeout_tip: 'Time waited for a read operation to complete.',
    retryInterval_tip: 'Time waited until retry to connect.',
    disabled_tip: 'Stop all operations on this driver, when disabled.',

    select: 'Select',
    select_tip: 'Select one of available drivers',

    add: 'New',
    edit: 'Change Settings',
    save: 'Save',
    remove: 'Remove',
    second: 'sec',
    status: 'Status'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js